import cn from "classnames";

import React from "react";

import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";

import style from "./style.module.scss";

const SearchBox = ({
  children,
  containerStyle,
}: {
  children: React.ReactNode;
  containerStyle?: React.CSSProperties;
}) => {
  const theme = useThemeData();
  const { isMobile } = usePlatform();

  return (
    <div
      className={cn(
        "rounded-md relative w-full px-[10px] pb-[30px]",
        { [style.mobile]: isMobile },
        theme.isDarkMode ? style.dark : style.light
      )}
      style={containerStyle}
    >
      {children}
    </div>
  );
};

export default SearchBox;
